export default "__VITE_ASSET__Cu1d64As__"